import { cx } from "@emotion/css";
import Skeleton from "library/Atoms/Skeleton";
import styles from "./styles";

const ListFiltersSkeleton = () => (
  <>
    <Skeleton className={cx(styles.filters)} />
    <Skeleton className={cx(styles.filters)} />
    <Skeleton className={cx(styles.filters)} />
  </>
);

export default ListFiltersSkeleton;
